import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { StateController } from '../helpers/state/state-management/state-controller';
import { getViewsForTopic } from '../helpers/api/topics-api';
import pointCache from '../helpers/state/point-cache';
import topicData from '../helpers/state/topic-data';

@customElement('topic-metadata')
export class TopicMetadata extends LitElement {
    amplitude_callsite: string = 'Topic Metadata';

    @property()
    onDarkBackground: boolean = false;

    @state()
    topicViewCount: number = 0;

    private readonly bindPointCacheState = new StateController(this, pointCache);
    private readonly bindTopicState = new StateController(this, topicData);

    async firstUpdated() {
        const telemetryEntries = await getViewsForTopic(
            this.amplitude_callsite,
            topicData.topicId,
            topicData.topicKey
        );

        this.topicViewCount = telemetryEntries
            .map((entry) => entry.value)
            .reduce((agg, v) => agg + v, 0);
    }

    render() {
        return html`
            <div class="topic-metadata__wrapper ${this.onDarkBackground ? 'topic-metadata--white' : 'topic-metadata--dark'}">
                ${topicData.topic?.updated_at ? html`
                    <span class="discover__metadata">
                        <mwc-icon class="topic-metadata__icon">edit</mwc-icon>
                        <span class="topic-metadata__title">${`Updated ${new Date(topicData.topic?.updated_at).toLocaleDateString()}`}</span>
                    </span>`
                : ''}
                <span class="discover__metadata">
                    <mwc-icon class="topic-metadata__icon">visibility</mwc-icon>
                    <span class="topic-metadata__title">${this.topicViewCount} Views</span>
                </span>
                <span class="discover__metadata">
                    <mwc-icon class="topic-metadata__icon">place</mwc-icon>
                    <span class="topic-metadata__title">${pointCache.allPoints?.length || 0} Spots</span>
                </span>
            </div>
        `;
    }

    static get styles() {
       return css`
            .topic-metadata__wrapper {
                display: flex;
            }

            .discover__metadata {
                display: flex;
                align-items: center;
                margin-right: 6px;
            }

            .topic-metadata__title {
                font-size: 13px;
            }

            .topic-metadata--white {
                color: var(--main-featured-color);
            }

            .topic-metadata--dark {
                color: var(--theme-lighter-text-color);
            }

            .topic-metadata__icon {
                --mdc-icon-size: .75rem;
                padding-right: 4px;
            }
        `;

    }
}
